import React from "react";
import './Header.css';
//import ReactDOM from 'react-dom';
import Menubar from '../Components/Menubar';
import Search from '../Components/Search';
//import Responsivecategory  from '../Components/Responsivecategory';
//import axios from 'axios';
//import { Link } from 'react-router-dom';
//import Address from '../Pop-up/Address';
import Signup from '../Pop-up/Signup';
import Location from '../Pop-up/Location';
import Signup2 from '../Pop-up/Signup2';
import Register from '../Pop-up/Register';
import OTPCheck from '../Pop-up/OTPCheck';
import AuthService from '../Services/auth.service';
import CartService from '../Services/cart.service';
//import Referafriend from '../Pop-up/Referafriend';
import { Modal, ModalHeader, ModalBody/* , ModalFooter, Button, Alert */ } from "reactstrap";
//import ReactLoading from 'react-loading';
//import CloseIcon from '@mui/icons-material/Close';
//import LocationOnIcon from '@mui/icons-material/LocationOn';
//import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Mobileheader from '../Components/Mobileheader';
//import Cartitemslide from '../Components/Cartitemslide';
//import Marquee from "react-fast-marquee";
//import Headertag  from '../Components/Headertag';
//import CallIcon from '@mui/icons-material/Call';
//import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
class Header extends React.Component {
    constructor() {
        super();
        this.state = {
            location: false, counter: '',
            modal: false,
            modal_large: false,
            location: false,
            place: [],
            id: [],
            mobile: false,
            counter: 0,
            cats: [],
            modal: false,
            modal_large: false,
            showSignup: false,
            showOtp: false,
            setPop: false,
            showRegister: false,
            showPopup: true,
            showLogin: false,
            showOTP: false,
            redirect: false,
            loading: '',
            uName: undefined,
            uMobile: undefined,
            uEmail: undefined,
            uNew: false,
            mmenu: 'collapse navbar-collapse ',
            toggle: false,
            check: false,
            toggleLeft: false,
            toggleRight: false,
            mmRight: 'collapse',
            mmLeft: 'collapse',
            loginMsg: '',
            loginMsgClass: '',
            otpMsg: '',
            otpMsgClass: '',
            cartClass: '',
            canvasClass: '',
            cartItems: [],
            cartTotal: [],
            cartGrandTotal: [],
        }
        this.tog_large = this.tog_large.bind(this);
        this.hideAll = this.hideAll.bind(this);
        this.handleNoChange = this.handleNoChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.loc_large = this.loc_large.bind(this);

    }
    hideAll() {
        this.setState({ showPopup: false })
        this.setState({ showSignup: false })
        this.setState({ showOtp: false })
        this.setState({ showRegister: false })
        this.setState({ showLogin: false })
        this.setState({ showOTP: false })
        this.setState({ loginMsg: '' })
        this.setState({ loginMsg: '' })
        this.setState({ otpMsg: '' })
    }
    handleNoChange(e) {
        this.hideAll()
        if (this.state.uNew) {
            this.setState({ showRegister: true })
        }
        else {
            this.setState({ showLogin: true })
        }

    }


    tog_large() {
        this.setState(prevState => ({
            modal_large: !prevState.modal_large
        }));


    }
    openCart(e) {
        e.preventDefault()
        this.getCart()
        this.setState({ cartClass: 'offcanvas-open' });
        this.setState({ canvasClass: 'show' });
    }
    closeCart(e) {
        e.preventDefault()
        this.setState({ cartClass: '' });
        this.setState({ canvasClass: '' });
    }

    /* getCounter(){
        try{
            const cart = AuthService.getCartitems()
            let count = cart.length
            //let total = parseFloat(0.00);
            if(cart.length > 0){
                this.setState({ counter: count }); 
               // alert(cart.length)
            }
            
        }
        catch(er){}
    } */
    componentDidMount() {

        /*  this.getCounter() */


        const textFromStorage = localStorage.getItem('location');
        //localStorage.clear('my-key'); 
        if (!textFromStorage) {
            this.loc_large()
            this.setState({ place: 'Location' });
        }
        else {

            this.setState({ place: textFromStorage });
        }


        /* AuthService.getCurrentUser();
            const user = AuthService.getCurrentUser();
            this.setState({ id:user })
            //console.log(user)
                if(!user){
                    this.setState({ loading:false });
                   // window.location.href = "/";
                }  
                else{
                    this.setState({ loading:true });
                } */

        const USR_TOKEN = localStorage.getItem("userToken")
        if (USR_TOKEN) {
            this.setState({ check: true })
            this.setState({ loggedin: true })
            CartService.update_cart()
        }
        else {
            CartService.update_cart_local()
        }




    }


    handleClose = () => {
        this.tog_large()
    }

    showRegister = () => {
        this.hideAll()
        this.setState({ showRegister: true })

    }
    showLogin = () => {
        this.hideAll()
        this.setState({ showLogin: true })

    }
    handleCancel = () => {
        this.tog_large()
        this.hideAll()
        this.setState({ showPopup: true })
    }

    handleOTP = async (otp) => {

        const delay = ms => new Promise(res => setTimeout(res, ms));
        if (!otp || isNaN(otp) || otp.toString().length < 4) {
            this.setState({ otpMsg: 'Invalid OTP' })
            this.setState({ otpMsgClass: 'text-danger' })
        }
        else {
            if (this.state.uNew) {

                await AuthService.checkOTP(otp, this.state.uMobile, this.state.uName, this.state.uEmail)
                    .then(response => {
                        this.setState({ otpMsg: response['msg'] })
                        this.setState({ otpMsgClass: response['class'] })
                        if (response['msg'] === 'OTP Verified') {

                            this.setState({ otpMsg: 'Registering user...' })
                            this.setState({ otpMsgClass: 'text-success' })
                            AuthService.register(this.state.uName, this.state.uMobile, this.state.uEmail)
                                .then(res => {

                                    if (res) {
                                        this.setState({ otpMsg: res['msg'] })
                                        this.setState({ otpMsgClass: res['class'] })
                                    }
                                    else {
                                        const user = AuthService.getCurrentUser()
                                        if (user) {
                                            this.setState({ otpMsg: 'Welcome...' })
                                            this.setState({ otpMsgClass: 'text-success' })
                                            window.location.href = "/"
                                        }
                                    }

                                })
                                .catch(er => { alert(er) })
                        }
                    })
                    .catch(err => { console.log(err) })

            }
            else {
                await AuthService.checkOTP(otp, this.state.uMobile)
                    .then(response => {
                        this.setState({ otpMsg: response['msg'] })
                        this.setState({ otpMsgClass: response['class'] })
                        this.setState({ showOTP: false })

                        if (response['msg'] === 'OTP Verified') {
                            this.setState({ showRegister: true })
                        }
                        else if (response['msg'] === "Invalid OTP") {
                            alert("ok")
                            this.setState({ showOTP: true })
                            this.setState({ otpMsg: 'Invalid OTP' })
                            this.setState({ otpMsgClass: 'text-danger' })
                        }
                        else {
                            //alert("ok")
                            this.setState({ showOTP: true })
                            //  this.setState({otpMsg:'Invalid OTP'})
                            // this.setState({otpMsgClass:'text-danger'})
                            //window.location.href = "/"
                            //alert("invalid otp")
                            //this.hideAll()
                            //this.setState({showOTP:true})
                        }
                        //this.hideAll()
                        //this.setState({showOTP:true})
                    })
                    .catch(err => { console.log(err) })

            }
        }
        // this.setState({showSignup:true})
        /// if (res==='OTP Send'){


        const user = await AuthService.getCurrentUser()
        if (user) {
            await delay(1000);
            this.setState({ otpMsg: 'Transfer Cart items....' })


            let cartArray = await CartService.getCart()
            let cart = cartArray['doc']['items']
            let ncart = [];
            let newArray = [];
            if (cart) {

                for (var i = 0; i < cart.length; i++) {

                    newArray = { 'item_code': cart[i]['item_code'], 'qty': cart[i]['qty'] }

                    ncart.push(newArray)
                }



            }

            console.log(ncart)
            localStorage.setItem("servercart", JSON.stringify(ncart));



            this.setState({ otpMsgClass: 'text-success' })
            await CartService.transfer_cart()
            await CartService.update_cart().then(resp => { console.log(resp) })
            await delay(3000);
            this.tog_large()
            this.setState({ loggedin: true })
            //window.location.href = "/my-account"
        }





        // }
        // else
        // alert("Error Sending OTP")


    }
    handleUpdate(e) {
        this.setState({ cartItems: [] })
        this.getCart()
        // CartService.update_cart()
    }
    async getCart() {
        const USR_TOKEN = localStorage.getItem("userToken")
        if (USR_TOKEN) {
            this.setState({ loggedIn: true })


            await CartService.getCart()
                .then(response => {
                    //console.log("getCart")
                    if (response['doc']['items'].length < 1) {
                        this.setState({ cartEmpty: true })
                    } else { this.setState({ cartEmpty: false }) }

                    this.setState({ cartItems: response['doc']['items'] })
                    this.setState({ cartTotal: response['doc']['total'] })
                    this.setState({ cartGrandTotal: response['doc']['total'] })
                    this.setState({ deliveryslot: response['delivery_slots'][0] })
                    if (response['doc']['shipping_address']) {
                        this.setState({ address: response['doc']['shipping_address'] })
                        this.setState({ addressStatus: true })
                    }

                    this.setState({ shipAddress: response['shipping_addresses'] })
                    this.setState({ shipAddressName: response['doc']['shipping_address_name'] })

                })
                .catch(err => { console.log(err) })

        }
        else {

            let cart = AuthService.getCartitems()

            if (cart) {
                this.setState({ cartQty: cart.length })
                let total = parseFloat(0.00);
                if (cart.length > 0) {
                    for (let itm in cart) {
                        total += parseFloat(cart[itm]['rate'] * cart[itm]['qty']);
                    }
                }
                this.setState({ cartTotal: total })
                this.setState({ cartItems: cart })
                this.setState({ cartGrandTotal: parseFloat(total) })
            }

        }
        CartService.update_cart()

    }
    handleSignup = async (mobileNo) => {
        if (!mobileNo || isNaN(mobileNo) || mobileNo.toString().length < 10) {
            this.setState({ loginMsg: 'Invalid Mobile No' })
            this.setState({ loginMsgClass: 'text-danger' })
        }
        else {
            this.setState({ uMobile: mobileNo })
            this.setState({ loginMsg: 'Sending OTP...' })
            this.setState({ loginMsgClass: 'text-info' })
            await AuthService.sendOTP(mobileNo)
                .then(response => {
                    // console.log(response)
                    if (response === 'To Signup') {
                        this.hideAll()
                        this.setState({ showRegister: true })
                    }
                    else {
                        //alert("ok")
                        this.setState({ loginMsg: response })
                        this.setState({ loginMsgClass: 'text-success' })
                        this.hideAll()
                        this.setState({ showOTP: true })
                    }
                })
                .catch(err => { console.log(err) })
        }
    }

    handleLogout(e) {
        AuthService.logout();
    }

    handleRegister = async (name, mobileNo, email) => {

        if (!mobileNo || !name || !email) {
            alert('Please fill all info')
        }
        else {
            //alert("y")
            this.setState({ uMobile: mobileNo })
            this.setState({ uName: name })
            this.setState({ uEmail: email })
            this.setState({ uNew: true })
            var res = await AuthService.sendOTP(mobileNo)
            this.hideAll()
            this.setState({ showOTP: true })

        }

    }
    modalOpen() {
        this.setState({ modal: true });
    }


    loc_large() {
        this.setState(prevState => ({
            location: !prevState.location
        }));
    }


    mobileMenu() {
        this.setState({ mobile: true });
    }

    render() {
        /* const USR_TYPE =''
        if (typeof window !== 'undefined') {
        const USR_TYPE = localStorage.getItem("userType")
        }else{
            const USR_TYPE =''
        } */
        //console.log(USR_TYPE)

        const USR_TYPE = localStorage.getItem("userType")
        /* const USR = JSON.parse(localStorage.getItem("user")); */
        const userJSON = localStorage.getItem("user");
        let USR;

        try {
            USR = JSON.parse(userJSON);
        } catch (error) {
            console.error("Error parsing user JSON:", error);
        }
        return <div>

            {/*<Headertag  location={this.loc_large} place={this.state.place}/>*/}


            <header className="header-wrapper">
                {/* <marquee className="fish-marquee"  direction="left"  height="100px">
            <img src="/assets/images/gif/fish-marquee.gif" width="100px"/>
        </marquee> */}
                <Modal
                    size="md"
                    isOpen={this.state.modal_large}
                    toggle={this.tog_large}
                    onHide={this.state.setPop}
                >
                    <ModalHeader toggle={() => this.setState({ modal_large: false })}>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.showPopup ? <Signup updateState={this.showLogin} handleRegister={this.showRegister} /> : ''}
                        {this.state.showLogin ? <Signup2 msg={this.state.loginMsg} msgclassName={this.state.loginMsgClass} updateState={this.handleSignup} handleClose={this.handleClose} handleCancel={this.handleCancel} /> : ''}
                        {this.state.showRegister ? <Register updateState={this.handleRegister} handleClose={this.handleClose} handleCancel={this.handleCancel} /> : ''}
                        {this.state.showOTP ? <OTPCheck handleNoChange={this.handleNoChange} msg={this.state.otpMsg} msgclassName={this.state.otpMsgClass} updateState={this.handleOTP} handleCancel={this.handleCancel} /> : ''}

                    </ModalBody>

                </Modal>


                <Modal
                    size="md"
                    isOpen={this.state.location}
                    show={this.state.location}
                    toggle={() => this.setState({ location: false })}
                    /* toggle={this.loc_large}  */
                    width="92%"
                >
                    {/* <ModalHeader toggle={() => this.setState({ location: false })}>
                                                    <span className=" close-btn-position m-1"><CloseIcon/></span>
                                                    </ModalHeader> */}
                    <ModalBody>
                        <Location handleCancel={this.handleCancel} />

                    </ModalBody>

                </Modal>





                <div className="container-fluid navigation-wrap start-style mob-d-none">
                    <div className="row pm-0 mt-3 mb-3">
                        <div className="col-md-2 text-center pb-2 logo-trans">
                            {/*<a href="/index"><img src="/assets/images/favicon/water-splash.png" className="mr-20px mob-d-none" alt=""  height="40px"/></a>*/}
                            <a href="/index"  ><img src="/assets/images/logo/footer-img.png" alt="" width="90px" height="80px" /></a>
                        </div>
                        {/*<div className="col-md-4 mob-d-none mt-4 ">
                     <div className="d-flex justify-center">
                    <div className=" mrgin-right mb-2 mt-2">
                        <CallIcon className="header-tag-icon"/><a href="tel:+18008902470" className="m-2 header-tag-text">1800 890 2470</a> 
                    </div>
                    <div className="mrgin-right mt-2 mb-2">
                        <EmailIcon className=" header-tag-icon m-1"/><a href="mailto:mail@prettypets.in" className="header-tag-text">mail@prettypets.in</a>
                    </div>
                    </div>
                </div>*/}
                        <div className="col-md-6 row none-x text-right pr-0 mob-d-none justify-center mt-4">
                            <Search />
                        </div>
                        <div className="col-md-4 row none-x text-right pr-0 mob-d-none mt-4">
                            <div className="header-tag-text head-mail-info">
                                <span className=" mt-1">
                                    <a href="tel:+18008902470" className="m-2 head-mail-info-color">Toll Free : 1800 890 2470</a>
                                </span>
                                <span className="header-tag-space mt-1">
                                    <a href="mailto:mail@prettypets.in" className="head-mail-info-color">mail@prettypets.in</a>
                                </span>
                            </div>
                            <div className="header-menu-nav">
                                <ul className="menu-nav">



                                    <li className="pr-0">
                                        <div className="header-tools d-flex m-3">
                                            <div className="cart-info d-flex align-self-center dropdown ">
                                                <a href="#" onClick={this.state.loggedin ? '' : this.tog_large}><i className="lnr lnr-user"></i></a>
                                                <div className="dropdown-content">
                                                    {(() => {
                                                        if (this.state.loggedin) {
                                                            return (<>
                                                                {/* <PersonIcon className="float-left log-user-name-icn"/> */}<span><p className="log-user-name ml-3">{USR.full_name}</p></span><hr className="user-outline" />
                                                                <a href="/my-profile">My Profile</a>
                                                                <a href="/my-orders">My Orders</a>
                                                                {USR_TYPE === 'agent' ? <> <a href="/agent-dashboard">Dashboard</a> <a href="/agent-sales">Customer Orders</a> </> : ''}
                                                                <a href="#" onClick={e => this.handleLogout(e)}>Log Out</a>
                                                            </>)
                                                        }
                                                        else {
                                                            return (<>
                                                                <a href="#" onClick={this.tog_large}>Log In / Sign Up</a>
                                                            </>)
                                                        }
                                                    })()}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pr-0">
                                        <div className="header-tools d-flex m-3">
                                            <div className="cart-info d-flex align-self-center">
                                                <a href="/cart" /* onClick={e => this.openCart(e)} */><i className="lnr lnr-cart"></i><span id="pro-count" className="counter">0</span></a>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pr-0">
                                        <div className="header-tools d-flex m-3">
                                            <div className="cart-info d-flex align-self-center">
                                                <a href="#0" onClick={this.loc_large} /* onClick={e => this.openCart(e)} */><i className="lnr lnr-map-marker"></i>{this.state.place}</a>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>











                <div className="col-md-3 align-self-center">
                    <div className="header-right-element d-flex justify-content-end">

                        {/* <!--Cart info Start --> */}






                    </div>
                    {/*   <!--Cart info End --> */}
                </div>



                {/* <!-- Header Nav End --> */}

                <Menubar />


                {/*  <!-- header menu --> */}
                <Mobileheader user={this.state.loggedin} login={this.tog_large} logout={e => this.handleLogout(e)} Location={this.loc_large} place={this.state.place} /* logged={this.state.id} */ />
            </header>

            {/*   <!-- Mobile Header Section Start --> */}
            {/*  <div className="mobile-category-nav d-lg-none mb-15px">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="hero-side-category">
                        <div className="category-toggle-wrap">
                            <button className="category-toggle" onClick={(e) =>this.mobileMenu}>
                              <i className="fa fa-bars"></i> All Categories</button>
                        </div>
                        <nav class={this.state.mobile ? 'category-menu d-block res-height' : 'category-menu res-height'}>
                            <ul>
                                <li><a href="/home">Home</a></li>
                                <li className="menu-item-has-children menu-item-has-children-1">
                                    <a href="/shop-list">Shop<i className="ion-ios-arrow-down"></i></a>
                                   
                                    <ul className="category-mega-menu category-mega-menu-1">
                                            <li><a href="/shop-list/dried-fish">Dried Fish</a></li>
                                            <li><a href="/shop-list/fish-curry">Fish Curry</a></li>
                                            <li><a href="/shop-list/fish-pickle">Fish Pickle</a></li>
                                            <li><a href="/shop-list/marine">Marine</a></li>
                                            <li><a href="/shop-list/prawns">Prawns</a></li>
                                            <li><a href="/shop-list/products">Products</a></li>
                                            <li><a href="/shop-list/river">River</a></li>
                                            <li><a href="/shop-list/shell">Shell</a></li>
                                    </ul>
                                </li>
                                <li className="menu-item"><a href="/about-us">About Us</a></li>
                                <li className="menu-item"><a href="/contact-us">Contact Us</a></li>
                                <li className="menu-item"><a href="/media"> Media</a></li>
                            
                                
                            </ul>
                        </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}



        </div>



    }
}
export default Header;